import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../redux-toolkit/hooks";
import { resetAuthState } from "../../redux-toolkit/slices/authSlice";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { toast } from "react-toastify";
import { useLogoutUserMutation } from "../../redux-toolkit/services/authService";

type Props = {};
const Logout = (props: Props) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [logoutUser, { isSuccess, isError, error }] = useLogoutUserMutation();

    useEffect(() => {
        // Trigger logout request when component mounts
        logoutUser({});
    }, [logoutUser]);

    useEffect(() => {
        if (isSuccess) {
            // Clear local storage and reset state only on successful logout
            localStorage.clear();
            dispatch(resetAuthState());
            navigate("/login", { replace: true });
            toast.success("Logout Successful");
        } else if (isError) {
            toast.error("Logout Failed");
            // Still navigate to login to ensure user is logged out client-side
            localStorage.clear();
            dispatch(resetAuthState());
            navigate("/login", { replace: true });
        }
    }, [isSuccess, isError, error, dispatch, navigate]);

    return <div></div>;
};
export default Logout;
